<template>
  <TwoCT
    :slides="mgnlPropsWithBtnColors.slides"
    :image-load-type="(mgnlPropsWithBtnColors.imageLoadType as ('eager' | 'lazy'))"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { WrapperProps, TwoCTBuilder } from './TwoCT.model';
import TwoCT from './TwoCT.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = TwoCTBuilder.build(props);

magnoliaGetters.migratePageLinkToCtaLink(mgnlProps);

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  slides: mgnlProps.slides?.map(slide => ({
    ...slide,
    titleColor: magnoliaGetters.getHexColor(slide.titleColor),
    subTextColor: magnoliaGetters.getHexColor(slide.subTextColor),
    ctaTextColor: slide.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(slide.ctaLink?.[0]?.ctaTextColor) : '#3c3c3b',
    buttonColor: slide.ctaLink?.[0]?.buttonColor ? magnoliaGetters.getHexColor(slide.ctaLink?.[0]?.buttonColor) : '#ffffff',
    borderColor: slide.ctaLink?.[0]?.borderColor ? magnoliaGetters.getHexColor(slide.ctaLink?.[0]?.borderColor) : '#3c3c3b',
    imageLoadType: mgnlProps.imageLoadType ?? 'lazy',
  })),
};
</script>
